function checkPassword(e) {
  let password_labels = window.passwordStrengthLabels;
  let password_messages = window.passwordMessages;
  var parentContainer = document.getElementById('password-strength-meter-container');
  var containerFeed = document.getElementById('password-strength-meter');
  var feed = document.getElementById('password-strength-meter-label');
  var errorContainer = document.getElementById('password-error');
  var input = e.currentTarget.value;
  const hasNumbers = /[0-9]/g;
  const hasUpperCase = /[A-Z]/g;
  const hasLowerCase = /[a-z]/g;
  const hasSymbols = /[!@#$%^&*]/g;
  let count = 0;

  errorContainer.innerHTML = '';
  
  if (input.match(hasNumbers)) {
    let total = input.match(hasNumbers);
    total = total ? total.length : 0;
    count += total * 2;
  }
  if (input.match(hasUpperCase)) {
    let total = input.match(hasUpperCase);
    total = total ? total.length : 0;
    count += total;
  }
  if (input.match(hasLowerCase)) {
    let total = input.match(hasLowerCase);
    total = total ? total.length : 0;
    count += total;
  }
  if (input.match(hasSymbols)) {
    let total = input.match(hasSymbols);
    total = total ? total.length : 0;
    count += total * 3;
  }

  // Reset all classes
    if (input.trim() === "") {
      feed.innerHTML = password_messages.no_password;
      errorContainer.innerHTML = password_rules;
    } else if (input.length < 8) {
      errorContainer.innerHTML = password_messages.password_rules.length;
    }
		if(count > 1) {
			parentContainer.classList.add('password-weak');
      feed.innerHTML = password_labels.weak;
		}else {
			parentContainer.classList.remove('password-weak')
		}
		if(count > 6) {
			parentContainer.classList.add('password-medium')
			feed.innerHTML = password_labels.medium;
		}else {
			parentContainer.classList.remove('password-medium')
		}
		if(count > 9 && (input).match(hasNumbers) && (input).match(hasUpperCase) && (input).match(hasLowerCase)) {
			parentContainer.classList.add('password-strong')
			feed.innerHTML = password_labels.strong;
		}else {
			parentContainer.classList.remove('password-strong')
		}
		if(count > 12 && (input).match(hasSymbols)) {
			parentContainer.classList.add('password-very-strong')
			feed.innerHTML = password_labels.very_strong;
		}else {
			parentContainer.classList.remove('password-very-strong')
		}
}

document.addEventListener('DOMContentLoaded', function () {
  var password = document.getElementById('RegisterForm-password');
  if (password) {
    password.addEventListener('input', checkPassword);
  }
});


// Check both password and password confirmation fields for match
document.addEventListener('DOMContentLoaded', function () {
  var password = document.getElementById('RegisterForm-password');
  var passwordConfirmation = document.getElementById('RegisterForm-password-confirmation');
  var matchErrorContainer = document.getElementById('password-match-error');
  var form = document.getElementById('create_customer');
  let password_messages = window.passwordMessages;

  /**
   * Password match check function
   * This function checks if the password and password confirmation fields match.
   * If they do not match, it displays an error message and prevents form submission.
   */
  function checkPasswordMatch() {
    var passwordValue = password.value;
    var passwordConfirmationValue = passwordConfirmation.value;

    // Only show error if both fields have content
    if (passwordValue && passwordConfirmationValue) {
      if (passwordValue !== passwordConfirmationValue) {
        matchErrorContainer.innerHTML = password_messages.password_rules.match;
        matchErrorContainer.style.display = 'block';
        form.addEventListener('submit', preventFormSubmit);
      } else {
        matchErrorContainer.innerHTML = '';
        matchErrorContainer.style.display = 'none';
        form.removeEventListener('submit', preventFormSubmit);
      }
    } else {
      // If either field is empty, hide the error message
      matchErrorContainer.innerHTML = '';
      matchErrorContainer.style.display = 'none';
      form.removeEventListener('submit', preventFormSubmit);
    }
  }

  function preventFormSubmit(event) {
    event.preventDefault();
  }

  // Add event listeners to both password fields
  if (password && passwordConfirmation) {
    password.addEventListener('input', checkPasswordMatch);
    passwordConfirmation.addEventListener('input', checkPasswordMatch);
  }
});

